import React, { ComponentProps, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContentMessage from '../../../_lib/components/ContentMessage/ContentMessage';
import { Namespace } from '../../../translation/namespace';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { CheckBoxParam, Form, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { SortableContentList } from '../../../_lib/components/SortableContentList';
import { DraggableAppLibraryPersonalListItem } from '../partials/AppLibraryPersonalListItem';
import { AnyParameter } from '../../../_lib/Form2/types/SonForm';
import ScrollArea from '../../../components/atoms/ScrollArea/ScrollArea';
import { Form2Modifier } from '../../../_lib/Form2/Form';
import { ContentListItemModifier } from '../../../_lib/components/ContentList/parials/ContentListItem';
import { ContentMessageModifier } from '../../../_lib/components/ContentMessage/ContentMessage';

type AppLibraryPersonalEditViewProps = {
  editForm: SonForm<CheckBoxParam<'selectedItems'>>;
  updateOrderForm: SonForm<AnyParameter>;
};

function AppLibraryPersonalEdit({ editForm, updateOrderForm }: AppLibraryPersonalEditViewProps) {
  const { t } = useTranslation(Namespace.AppLibraryPersonal);
  const { delayedRefresh } = useRefreshBlock();
  const { formProps, fetchState, params } = useForm({
    form: editForm,
  });

  useEffect(() => {
    if (fetchState.type === 'success') {
      return delayedRefresh();
    }
  }, [delayedRefresh, fetchState.type]);

  const items = params.getAllByName('selectedItems').map(item => {
    return { ...item, id: item.value };
  });

  return (
    <div className="app-library-personal">
      <ScrollArea to={100} bottomOffset={10}>
        <div className="app-library-personal__container">
          <ContentMessage modifier={ContentMessageModifier.PADDING_BOTTOM} text={t('optionalEditInfo')} />
          <Form id="app-library-personal-form" modifier={Form2Modifier.NO_PADDING} {...formProps}>
            <div className="app-library-personal__list-container">
              <SortableContentList items={items} form={updateOrderForm} hasDarkDragLayerBackground>
                {item => (
                  <DraggableAppLibraryPersonalListItem
                    key={item.id}
                    modifier={ContentListItemModifier.NO_PADDING_VERTICAL}
                    {...item}
                  />
                )}
              </SortableContentList>
            </div>
            <SubmitButton
              buttonLabel={t('saveButton')}
              messageFail={t('status.fail')}
              messageSuccess={t('status.success')}
              messageSending={t('status.sending')}
              fetchState={fetchState}
            />
          </Form>
        </div>
      </ScrollArea>
    </div>
  );
}

export const AppLibraryPersonalEditView = asFetchableView(AppLibraryPersonalEdit);
export type AppLibraryPersonalEditView = ComponentProps<typeof AppLibraryPersonalEditView>;
